import formDataApi from './formDataAxios.service';
import api from './axios.service';
const formDataAxios = formDataApi;
const axios = api;

const uploadFile = async (payload) => {
    try {
        let file = payload.file;
        let formData = new FormData();
        formData.append('file', file);

        let response = await formDataAxios.post(`/upload`, formData);
        return response.data;
    } catch (error) {
        return error?.response?.data || { error: error.message };
    }
}

const deleteUploadedFile = async (payload) => {
    try {
        let response = await axios.post(`/deleteUploadedFile`, payload);
        return response.data;
    } catch (error) {
        return error?.response?.data || { error: error.message };
    }
}

export {
    uploadFile,
    deleteUploadedFile
};
